import authAdminSlice from "./authAdminSlice";
import authTenantSlice from "./authTenantSlice";
import adjustmentOrderSlice from "./adjustmentOrderSlice";
import adminNotificationSlice from "./adminNotificationSlice";
import brandSlice from "./brandSlice";
import categorySlice from "./categorySlice";
import customerSlice from "./customerSlice";
import dashboardSlice from "./dashboardSlice";
import inventorySlice from "./inventorySlice";
import notificationSlice from "./notificationSlice";
import planSlice from "./planSlice";
import productSlice from "./productSlice";
import purchaseSlice from "./purchaseSlice";
import reportSlice from "./reportSlice";
import salesSlice from "./salesSlice";
import stockSlice from "./stockSlice";
import supplierSlice from "./supplierSlice";
import supportRequestSlice from "./supportRequestSlice";
import tenantSlice from "./tenantSlice";
import tenantSignupRequestSlice from "./tenantSignupRequestSlice";
import tenantDepartmentSlice from "./tenantDepartmentSlice";
import tenantUserSlice from "./tenantUserSlice";
import transactionSlice from "./transactionSlice";
import unitSlice from "./unitSlice";
import warehouseSlice from "./warehouseSlice";

const rootReducer = {
  authAdmin: authAdminSlice,
  authTenant: authTenantSlice,
  adjustmentOrder: adjustmentOrderSlice,
  adminNotification: adminNotificationSlice,
  brand: brandSlice,
  category: categorySlice,
  customer: customerSlice,
  dashboard: dashboardSlice,
  inventory: inventorySlice,
  notification: notificationSlice,
  plan: planSlice,
  product: productSlice,
  purchase: purchaseSlice,
  report: reportSlice,
  sales: salesSlice,
  stock: stockSlice,
  supplier: supplierSlice,
  supportRequest: supportRequestSlice,
  tenant: tenantSlice,
  tenantSignupRequest: tenantSignupRequestSlice,
  tenantDepartment: tenantDepartmentSlice,
  tenantUser: tenantUserSlice,
  transaction: transactionSlice,
  unit: unitSlice,
  warehouse: warehouseSlice,
};

export default rootReducer;
